<template>
  <CreateEditUserForm />
</template>

<script setup lang="ts"></script>
